import loadJS from './loadJS';

loadJS('https://static.zhongan.com/website/assets/subject/common/thirdTips/assets/scripts/page.js', () => null);
